import React, { Fragment } from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { LinkedNavNode } from '../../../features/linkedNav/linkedNav';

type Props = {
  navStack: LinkedNavNode[];
  onSelect: (node: LinkedNavNode) => void;
};

// Trail of every catalog the guest has "Explore"d into so far (root -> ... -> current).
// Tapping any ancestor pops back to it; the current (last) node is plain text.
const ExploreBreadcrumb: React.FC<Props> = ({ navStack, onSelect }) => {
  return (
    <div className="flex items-center overflow-x-auto whitespace-nowrap gap-2 text-xs text-on-surface-variant mb-2">
      {navStack.map((node, i) => {
        const isCurrent = i === navStack.length - 1;
        return (
          <Fragment key={`${node.qr}_${i}`}>
            {i !== 0 && (
              <ChevronRightIcon className="w-4 h-4 flex-shrink-0" />
            )}
            <span
              className={
                isCurrent
                  ? 'font-semibold text-on-surface'
                  : 'cursor-pointer underline'
              }
              onClick={() => {
                if (!isCurrent) {
                  onSelect(node);
                }
              }}
            >
              {node.name || (i === 0 ? 'Menu' : `Catalog ${i}`)}
            </span>
          </Fragment>
        );
      })}
    </div>
  );
};

export default ExploreBreadcrumb;
